import { DonationUnit } from 'gql/types';

const DEVIATION_THRESHOLD = 0.08;

interface IIsFailedDonationParams {
  approvedMl?: number;
  actual?: number;
  units?: DonationUnit;
}

export const isFailedDonation = ({
  approvedMl,
  actual,
}: IIsFailedDonationParams): boolean => {
  if (approvedMl === undefined || actual === undefined || approvedMl === 0) {
    return false;
  }

  return Math.abs(actual - approvedMl) / approvedMl > DEVIATION_THRESHOLD;
};
